import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useState} from "react";
import {toast} from "react-toastify";
import {useForm} from "react-hook-form";
import Modal from "../../../../components/UI/Modal";
import Input from "../../../../components/UI/form/Input";
import Button from "../../../../components/UI/Button";
import {setValidationMessage} from "../../../../util/validationMessage";
import {storeShippingCost, updateShippingCost} from "../../../../api/shippingCost";

const ShippingCostForm = ({editRecord = null, openModal, setOpenModal, setShippingCost}) => {

  const {setValue, reset, register, setError, handleSubmit, formState: { errors }} = useForm({
    defaultValues:{
      name: editRecord ? editRecord.name : '',
      min_quantity: editRecord ? editRecord.min_quantity : '',
      cost: editRecord ? editRecord.cost : '',
    }
  });

  const queryClient = useQueryClient();
  const [toastId, setToastId] = useState(null);

  const {isPending, mutate} = useMutation({
    mutationFn: editRecord ? (data) => updateShippingCost(editRecord.id, data) : storeShippingCost,
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (res) => {
      toast.update(toastId, { render: `Shipping Cost ${editRecord ? 'Updated' : 'Added'}`, type: "success", isLoading: false, autoClose: true });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'shipping_costs',
      });
      setOpenModal(false)
      setShippingCost(null)
      reset();

    },
    onError: (error) => {
      let errorMsg = "Something happened!";
      if (error && error.message && error.message.errors) {
        setValidationMessage(error.message.errors, setError);
        errorMsg = error.message.message;
      }

      toast.update(toastId, { render: errorMsg, type: "error", isLoading: false, autoClose: true });
    }
  });

  const onSubmit = (data) => {
    mutate(data)
  }

  return(
    <>
      <Modal title={`${editRecord ? 'Edit' : 'Add'} Shipping Cost`} open={openModal} setOpen={setOpenModal}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col_6 pr_20">
              <Input label="Name"
                     name="name"
                     errors={errors}
                     validationRules={{required: true, type: 'text'}}
                     register={register}/>
            </div>

            <div className="col_3 pr_20">
              <Input label="Min. Quantiy"
                     name="min_quantity"
                     errors={errors}
                     validationRules={{required: true, type: 'number'}}
                     register={register}/>
            </div>

            <div className="col_3">
              <Input label="Cost"
                     name="cost"
                     type={'cost'}
                     errors={errors}
                     validationRules={{required: true, type: 'number'}}
                     register={register}/>
            </div>
          </div>


            <div className="d_flex_end">
              <Button
                text="save"
                isPending={isPending}
                type={"submit"}
              />
          </div>
        </form>
      </Modal>
    </>
  )
}

export default ShippingCostForm